<template>
  <div>

    <b-form-select v-model="selected" :options="options" size="sm" class="mt-3"></b-form-select>
  </div>
</template>

<script>
  export default {

    props: {
      options: Array,

    },

    data() {
      return {
        selected: null,

      }
    },

    methods: {

      preSelect(val){
        this.selected = val
      }
    },

    watch: {
      selected: function(val) {
        this.$emit('selected', this.selected)
      }
    }


  }
</script>



// WEBPACK FOOTER //
// src/components/Selects.vue